var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBannerblob2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1072.438,
    height: 1067.268,
    viewBox: "0 0 1072.438 1067.268",
    transform: "rotate(150)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.213,
    y1: 0.37,
    x2: 0.895,
    y2: 0.657,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f93"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "blob-haikei1",
    transform: "matrix(-0.695, -0.719, 0.719, -0.695, 383.998, 722.545)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M352.666-89c16.672,61.467-32.872,130.582-34.287,239.841C317.12,260.1,363.99,409.209,287.551,521.557s-276.5,187.932-410.5,129.7c-134-58.085-202.264-249.987-160.742-379.539S-91.183,74.962,2.714-2.828c93.74-77.937,130.229-166.315,190.153-183.814,59.767-17.352,142.969,36.322,159.8,97.642",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerblob2);
export default __webpack_public_path__ + "static/media/bannerblob2.fded389b0eec1a184c7bdd3c2ad6158e.svg";
export { ForwardRef as ReactComponent };